import React from 'react';
import { GallerySimpleImage } from '$partials/media';
import GalleryVideo from '$partials/media/gallery-video.jsx';
import { useMediaGallery } from '$partials/global/media-gallery.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PropertyDetailSection}
 */
const PropertyDetailSection = ({
    heading,
    body,
    images
}) => {
    const gallery = useMediaGallery();
    return (
        <div className='module-product-detail-section theme-light bg-main-background'>
            <div className='layout-container layout-site-outer-padding py-16 sm:py-40 md:py-48'>
                <div className='flex gap-y-32 flex-col md:flex-row col-wrapper'>
                    {(heading || body) && (
                        <div className='max-sm:max-w-[65ch] sm:w-9/12 md:w-4/12 col-padding'>

                            {heading && (
                                <h2 className='type-style-2'>{heading}</h2>
                            )}
                            {body && (
                                <div
                                    className='type-style-body-r mt-16  '
                                    dangerouslySetInnerHTML={{ __html: body }}/>
                            )}
                        </div>
                    )}
                    {images?.length > 0 && (
                        <div className='w-full md:w-8/12'>
                            <div className='flex flex-wrap gap-y-24'>
                                {images.map((img, idx) => {
                                    const video = img.media.video || img.media.videoEmbed;
                                    const hasVideo = !!video?.src;
                                    let orientation = 'landscape';

                                    if (img.media.video) {
                                        if (img.media.video.height > img.media.video.width) {
                                            orientation = 'portrait';
                                        }
                                    } else if (img.media.externalVideo) {
                                        if (img.media.externalVideo.height > img.media.externalVideo.width) {
                                            orientation = 'portrait';
                                        }
                                    } else if (img.media.image) {
                                        if (img.media.image.height > img.media.image.width) {
                                            orientation = 'portrait';
                                        }
                                    }
                                    const wrapperClass = orientation === 'portrait' ? 'w-1/2' : 'w-full';

                                    return (
                                        <figure
                                            className={`col-padding ${wrapperClass}`}
                                            key={idx}
                                            onClick={hasVideo ? () => {} : () => gallery.setGalleryInitialId(img.id)}>
                                            {hasVideo ? (
                                                <div className='w-full'>
                                                    {img.media.videoEmbed && (
                                                        <GalleryVideo
                                                            cursorVisible={false}
                                                            playButtonPosition='center'
                                                            {...img.media.videoEmbed}
                                                            poster={img.media.videoEmbed?.poster?.url} />
                                                    )}
                                                    {img.media.video && (
                                                        <GalleryVideo
                                                            cursorVisible={false}
                                                            playButtonPosition='center'
                                                            {...img.media.video} />
                                                    )}
                                                </div>
                                            ) : (
                                                <GallerySimpleImage
                                                    {...img.media.image}
                                                    className='w-full' />
                                            )}
                                            {img?.caption && (
                                                <figcaption className='type-style-caption mt-8'>
                                                    {img.caption}
                                                </figcaption>
                                            )}
                                        </figure>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PropertyDetailSection;
